export default {
  data() {
    return {
      // eslint-disable-next-line no-undef
      editableMixin: editableProps
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/editablePropety.js